// extracted by mini-css-extract-plugin
module.exports = {"wrapperChart":"RadarChart_wrapperChart__1Qmz4","legend":"RadarChart_legend__TFDn4"};